import { INVALID, VALID } from '../PropertyValidationStatus';
// @ts-expect-error Not typed yet
import DomainRegex from 'PatternValidationJS/patterns/Domain';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { INVALID_DOMAIN_FORMAT } from '../PropertyValidationErrorCodes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
// Based on URI spec: https://www.rfc-editor.org/rfc/rfc3986#appendix-B
const DOMAIN_PROTOCOL_REGEX = /(^[^:/?#]*:(?:\/+)?)?(?:.*)/;
function getDomainProtocol(domain) {
  // Cast OK due to (?:.*) capture group always matching
  const match = domain.match(DOMAIN_PROTOCOL_REGEX);
  return match[1];
}
export function domainContainsProtocol(domain) {
  return Boolean(domain && getDomainProtocol(domain) !== undefined);
}
export function getDomainProtocolInfo(domain) {
  if (!domain) {
    return {
      domain,
      protocol: undefined
    };
  }
  const protocol = getDomainProtocol(domain);
  if (protocol !== undefined) {
    return {
      domain: domain.replace(protocol, ''),
      protocol
    };
  }
  return {
    domain,
    protocol: undefined
  };
}
function removeProtocolAndWwwPrefix(domain) {
  return domain.replace(/^https?:\/\//i, '').replace(/^(www\.)?/i, '');
}
function domainContainsPath(domain) {
  const parsedDomain = removeProtocolAndWwwPrefix(domain);
  return parsedDomain.indexOf('/') !== -1;
}
function getDomainPathInfo(domain) {
  if (!domain) {
    return {
      domain,
      path: undefined
    };
  }
  const parsedDomain = removeProtocolAndWwwPrefix(domain);

  // We can cast this here because the regex will match anything, even an empty
  // string (.* will match blank)
  const match = parsedDomain.match(/([^/]*)(.*)/);
  if (!domainContainsPath(domain)) {
    return {
      domain: parsedDomain,
      path: undefined
    };
  }
  return {
    domain: match[1],
    path: match[2]
  };
}
function isValidDomain(domain) {
  const {
    domain: parsedDomain
  } = getDomainPathInfo(domain);
  if (!parsedDomain) {
    return false;
  }
  return DomainRegex.test(parsedDomain);
}
function validateDomain(domain) {
  if (!domain) {
    return true;
  }
  return isValidDomain(domain) && !domainContainsPath(domain) && !domainContainsProtocol(domain);
}
function getErrorMessage(value) {
  const {
    protocol
  } = getDomainProtocolInfo(value);
  const {
    path,
    domain
  } = getDomainPathInfo(value);
  if (protocol && path) {
    return {
      code: INVALID_DOMAIN_FORMAT,
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.propertyValidationErrorMessages.invalidDomainBoth",
        options: {
          domain,
          protocol,
          path
        }
      })
    };
  }
  if (protocol) {
    return {
      code: INVALID_DOMAIN_FORMAT,
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.propertyValidationErrorMessages.invalidDomainProtocol",
        options: {
          domain,
          protocol
        }
      })
    };
  }
  if (path) {
    return {
      code: INVALID_DOMAIN_FORMAT,
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.propertyValidationErrorMessages.invalidDomainPath",
        options: {
          domain,
          path
        }
      })
    };
  }
  return {
    code: INVALID_DOMAIN_FORMAT,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.propertyValidationErrorMessages.invalidDomainFormat"
    })
  };
}
function createValidationDetails(validationRequest) {
  const isValid = validateDomain(validationRequest.value);
  if (validationRequest.value && !isValid) {
    return {
      errors: [getErrorMessage(validationRequest.value)],
      validationRequest,
      validationStatus: INVALID
    };
  }
  return {
    errors: [],
    validationRequest,
    validationStatus: VALID
  };
}

/**
 * Validator for ensuring strings have the correct format to be an domain
 * This validator should work for any domain property. If a property
 * requires a more specific validation a new custom validator should be used.
 */
export const domainPropertyValidator = validationRequest => Promise.resolve(createValidationDetails(validationRequest));